import { Emoji } from './Emoji.jsx'
import { isSystemCategory } from '../categoryTree.js'

// Icona di una categoria. Quelle di sistema (create dalle sync, oggi solo
// "Even") non hanno un'emoji scelta dall'utente ma il marchio dell'app che le
// alimenta: unico posto in cui si decide, così lista, picker e riepiloghi
// restano coerenti.
export function CategoryIcon({ category, size = '1.4rem', fallback = '💸' }) {
  if (isSystemCategory(category)) {
    const px = `calc(${size} * 0.9)`
    return (
      <img
        src="/icons/even-mark.svg"
        alt=""
        style={{ display: 'block', width: px, height: px }}
      />
    )
  }
  return <Emoji symbol={category?.icon ?? fallback} size={size} />
}
